import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsSeparator'
})
export class ThousandsSeparatorPipe implements PipeTransform {

  transform(val: string, args?: any): string {
    if (val !== undefined && val !== null) 
    {
      if (val == '' || /[a-zA-Z ]/.test(val) || isNaN(parseInt(val)))
        return '';
      else {
        if (typeof val === 'string')
          val = val.replace(/[\.,]/g, '');
        return parseInt(val).toLocaleString();
      }
    } else {
      return '';
    }
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/application-pipes-module/pipes/thousands-separator.pipe.ts